function isNight(date) {
    const currDate = date || new Date();
    const currTime = currDate.getHours();
    return currTime >= 19 || currTime < 7;
}
export { isNight };
